import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import { adjustAmount, QUICK_AMOUNTS, type BetCurrency } from "./betSettings.js";

export function BetAmount({
  value,
  onChange,
  currency,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  currency: BetCurrency;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="cx-bet-amount">
      <div>
        <span className="cx-amount-control">
          <Button
            variant="ghost"
            disabled={disabled}
            aria-label={t("bet.decrease")}
            onClick={() => onChange(adjustAmount(value, String(-currency.minBet), currency))}
          >
            {t("bet.minus")}
          </Button>
          <input
            aria-label={t("bet.amount")}
            className="cx-input"
            type="text"
            inputMode="decimal"
            value={value}
            disabled={disabled}
            maxLength={25}
            onChange={(event) => onChange(event.target.value)}
          />
          <Button
            variant="ghost"
            disabled={disabled}
            aria-label={t("bet.increase")}
            onClick={() => onChange(adjustAmount(value, String(currency.minBet), currency))}
          >
            {t("bet.plus")}
          </Button>
        </span>
      </div>
      <div className="cx-quick-amounts">
        {QUICK_AMOUNTS.map((amount) => (
          <Button
            key={amount}
            variant="ghost"
            disabled={disabled || Number(amount) < currency.minBet || Number(amount) > currency.maxBet}
            aria-label={t("bet.quick", { amount })}
            onClick={() => onChange(amount)}
          >
            {amount}
          </Button>
        ))}
      </div>
    </div>
  );
}
